export const LinkData = [
    { title: 'Anxiety', url: '/blog/Anxiety' },
    { title: 'Depression', url: '/blog/Depression' },
    { title: 'Mindfulness', url: '/blog/Mindfulness' },
    { title: 'Phobias', url: '/blog/Phobias' },
    { title: 'Paranoia', url: '/blog/Paranoia' },
    { title: 'Stress', url: '/blog/Stress' },
  ];